// 資料ダウンロード一覧ページ
// import { getFormattedDownloadCount } from '../utils/download-counter.js';
import { trackWhitepaperListView } from '../utils/analytics.js';
import { Header } from '../components/header.js';
import { Footer } from '../components/footer.js';
import { isAvailable, getAvailableCount, COMING_SOON_MESSAGE, NEW_RELEASE_CONFIG } from '../config/whitepaper-availability.js';

export function DownloadListPage() {
  // ページビューのトラッキング
  trackWhitepaperListView();
  
  // カテゴリーフィルター機能を追加
  const initCategoryFilter = () => {
    setTimeout(() => {
      const filterButtons = document.querySelectorAll('.category-filter-btn');
      const downloadCards = document.querySelectorAll('.download-card');
      
      filterButtons.forEach(button => {
        button.addEventListener('click', () => {
          const category = button.dataset.category;
          
          // アクティブボタンの切り替え
          filterButtons.forEach(btn => btn.classList.remove('active'));
          button.classList.add('active');
          
          // カードの表示/非表示
          downloadCards.forEach(card => {
            if (category === 'all' || card.dataset.category === category) {
              card.style.display = 'block';
            } else {
              card.style.display = 'none';
            }
          });
        });
      });
    }, 100);
  };
  
  // ページ表示時にフィルター機能を初期化
  initCategoryFilter();
  
  const whitepapers = [
    {
      id: 'wp01',
      title: '「検討します」を「申し込みます」に変える魔法の一言',
      description: '購入検討者の心理を理解し、クロージング率を3倍にする実践的テクニック',
      thumbnail: '/images/wp01-thumb.png',
      category: 'クロージング',
      pages: 10,
      fileSize: '1.16MB',
      // downloadCount: getFormattedDownloadCount('wp01')
    },
    {
      id: 'wp02',
      title: '初回面談30分で専任媒介を獲得する面談シート',
      description: '時間配分から質問の流れまで、成功率87%の面談手法を完全公開',
      thumbnail: '/images/wp02-thumb.png',
      category: '面談術',
      pages: 12,
      fileSize: '2.3MB',
      // downloadCount: getFormattedDownloadCount('wp02')
    },
    {
      id: 'wp03',
      title: '年収を聞かずに予算を把握する7つの質問術',
      description: 'お客様との関係を壊さずに、正確な予算を把握する心理テクニック',
      thumbnail: '/images/wp03-thumb.png',
      category: '顧客心理',
      pages: 11,
      fileSize: '1.8MB',
      // downloadCount: getFormattedDownloadCount('wp03')
    },
    {
      id: 'wp04',
      title: '購入検討者の心理段階別アプローチ法',
      description: 'お客様の心理状態を見極め、最適なタイミングで最適な提案をする方法',
      thumbnail: '/images/wp04-thumb.png',
      category: '心理分析',
      pages: 15,
      fileSize: '2.5MB',
      // downloadCount: getFormattedDownloadCount('wp04')
    },
    {
      id: 'wp05',
      title: '成約率を上げる物件案内チェックリスト',
      description: 'プロが実践する物件案内の極意！案内前・案内中・案内後の完全ガイド',
      thumbnail: '/images/wp05-thumb.png',
      category: '実践ツール',
      pages: 18,
      fileSize: '3.2MB',
      // downloadCount: getFormattedDownloadCount('wp05')
    },
    {
      id: 'wp06',
      title: '購入申込を獲得する交渉術',
      description: '売主・買主の間で「三方よし」を実現する価格交渉とクロージングの極意',
      thumbnail: '/images/wp06-thumb.png',
      category: '交渉術',
      pages: 20,
      fileSize: '2.8MB',
      // downloadCount: getFormattedDownloadCount('wp06')
    },
    {
      id: 'wp07',
      title: '「他社も見ています」と言われた時の切り返し話法20選',
      description: '競合に負けない心理テクニックと信頼構築の極意',
      thumbnail: '/images/wp07-thumb.png',
      category: '競合対策',
      pages: 14,
      fileSize: '2.1MB',
      // downloadCount: getFormattedDownloadCount('wp07')
    },
    {
      id: 'wp08',
      title: '内見後に音信不通になった客を復活させる3通のLINE',
      description: '心理学に基づいた復活率78%のメッセージ術',
      thumbnail: '/images/wp08-thumb.png',
      category: 'フォローアップ',
      pages: 12,
      fileSize: '1.9MB',
      // downloadCount: getFormattedDownloadCount('wp08')
    },
    {
      id: 'wp09',
      title: 'ローン事前審査を初回面談で通す5ステップ',
      description: '成功率85%の時短営業術',
      thumbnail: '/images/wp09-thumb.png',
      category: '効率化',
      pages: 13,
      fileSize: '2.0MB',
      // downloadCount: getFormattedDownloadCount('wp09')
    },
    {
      id: 'wp10',
      title: '内見3件以内で決める！事前ヒアリング完全ガイド',
      description: '効率的な物件案内で成約率90%を実現',
      thumbnail: '/images/wp10-thumb.png',
      category: '効率化',
      pages: 14,
      fileSize: '2.2MB',
      // downloadCount: getFormattedDownloadCount('wp10')
    },
    {
      id: 'wp11',
      title: '購入申込書の記入率を80%に上げる心理テクニック',
      description: 'その場で決断させる極意と実践的アプローチ',
      thumbnail: '/images/wp11-thumb.png',
      category: 'クロージング',
      pages: 14,
      fileSize: '2.1MB',
      // downloadCount: getFormattedDownloadCount('wp11')
    },
    {
      id: 'wp12',
      title: '仲介手数料半額と言われた時の価値の伝え方',
      description: '価格競争に巻き込まれない差別化戦略',
      thumbnail: '/images/wp12-thumb.png',
      category: '競合対策',
      pages: 14,
      fileSize: '2.0MB',
      // downloadCount: getFormattedDownloadCount('wp12')
    },
    {
      id: 'wp13',
      title: 'ポータルからの反響を来店に繋げる返信テンプレート集',
      description: '反響からの来店率を3倍にする実践的メール術',
      thumbnail: '/images/wp13-thumb.png',
      category: '集客',
      pages: 14,
      fileSize: '2.1MB',
      // downloadCount: getFormattedDownloadCount('wp13')
    },
    {
      id: 'wp14',
      title: '購入客が本当に知りたい10の質問と模範回答',
      description: '顧客心理を理解した完璧な回答術',
      thumbnail: '/images/wp14-thumb.png',
      category: '顧客心理',
      pages: 14,
      fileSize: '1.8MB',
      // downloadCount: getFormattedDownloadCount('wp14')
    },
    {
      id: 'wp15',
      title: '信頼を勝ち取る車内トーク術',
      description: '限られた移動時間を最強の営業タイムに変える方法',
      thumbnail: '/images/wp15-thumb.png',
      category: '面談術',
      pages: 14,
      fileSize: '2.2MB',
      // downloadCount: getFormattedDownloadCount('wp15')
    },
    {
      id: 'wp16',
      title: '住宅ローン通らない客を通す裏ワザ15選',
      description: '諾めていた顧客を救う実践的アプローチ',
      thumbnail: '/images/wp16-thumb.png',
      category: 'ローン対策',
      pages: 14,
      fileSize: '2.2MB',
      // downloadCount: getFormattedDownloadCount('wp16')
    },
    {
      id: 'wp17',
      title: '内見中やってはいけないNG行動ワースト10',
      description: 'せっかくの物件を台無しにしない内見術',
      thumbnail: '/images/wp17-thumb.png',
      category: '物件案内',
      pages: 14,
      fileSize: '1.4MB',
      // downloadCount: getFormattedDownloadCount('wp17')
    },
    {
      id: 'wp18',
      title: '購入決断を1週間早める緊急性演出法',
      description: '適切なプレッシャーで背中を押す技術',
      thumbnail: '/images/wp18-thumb.png',
      category: 'クロージング',
      pages: 14,
      fileSize: '1.5MB',
      // downloadCount: getFormattedDownloadCount('wp18')
    },
    {
      id: 'wp19',
      title: '賃貸vs購入で購入が圧勝するシミュレーション術',
      description: '数字で納得させる最強の説得ツール',
      thumbnail: '/images/wp19-thumb.png',
      category: '説得術',
      pages: 14,
      fileSize: '2.3MB',
      // downloadCount: getFormattedDownloadCount('wp19')
    },
    {
      id: 'wp20',
      title: '紹介率60%を実現する購入後フォローの仕組み',
      description: '一度の成約が次の10件につながる方法',
      thumbnail: '/images/wp20-thumb.png',
      category: 'フォローアップ',
      pages: 14,
      fileSize: '2.2MB',
      // downloadCount: getFormattedDownloadCount('wp20')
    },
    {
      id: 'wp21',
      title: '両手率80%！自社物件の見せ方と営業トーク',
      description: '買主・売主の両方から選ばれる物件紹介術',
      thumbnail: '/images/wp21-thumb.png',
      category: '物件案内',
      pages: 14,
      fileSize: '2.3MB',
      // downloadCount: getFormattedDownloadCount('wp21')
    },
    {
      id: 'wp22',
      title: '価格交渉で95%の勝率を叩き出す5つのテクニック',
      description: '売主も買主も納得する交渉の進め方',
      thumbnail: '/images/wp22-thumb.png',
      category: '交渉術',
      pages: 14,
      fileSize: '2.1MB',
      // downloadCount: getFormattedDownloadCount('wp22')
    },
    {
      id: 'wp23',
      title: '投資用マンションを確実に売る方法',
      description: 'オーナーの損失を最小化する戦略的売却術',
      thumbnail: '/images/wp23-thumb.png',
      category: '説得術',
      pages: 14,
      fileSize: '2.4MB',
      // downloadCount: getFormattedDownloadCount('wp23')
    },
    {
      id: 'wp24',
      title: '離婚に伴う不動産売却の進め方と注意点',
      description: 'デリケートな案件を円滑に進める配慮と手続き',
      thumbnail: '/images/wp24-thumb.png',
      category: '特殊案件',
      pages: 14,
      fileSize: '2.2MB',
      // downloadCount: getFormattedDownloadCount('wp24')
    },
    {
      id: 'wp25',
      title: '高齢者の住み替えサポート完全ガイド',
      description: '老後の安心を提供する住み替え提案術',
      thumbnail: '/images/wp25-thumb.png',
      category: '特殊案件',
      pages: 14,
      fileSize: '2.3MB',
      // downloadCount: getFormattedDownloadCount('wp25')
    },
    {
      id: 'wp26',
      title: '新婚30代夫婦の理想の家探し術',
      description: '将来設計を踏まえた物件提案のポイント',
      thumbnail: '/images/wp26-thumb.png',
      category: '顧客心理',
      pages: 14,
      fileSize: '2.1MB',
      // downloadCount: getFormattedDownloadCount('wp26')
    },
    {
      id: 'wp27',
      title: '初対面で信頼を築く話法',
      description: '心理学に基づいた最速信頼構築テクニック',
      thumbnail: '/images/wp27-thumb.png',
      category: '面談術',
      pages: 16,
      fileSize: '2.2MB',
      // downloadCount: getFormattedDownloadCount('wp27')
    },
    {
      id: 'wp28',
      title: 'オンライン面談で成約率50%超えの方法',
      description: '画面越しでも心をつかむWEB接客術',
      thumbnail: '/images/wp28-thumb.png',
      category: '面談術',
      pages: 14,
      fileSize: '2.5MB',
      // downloadCount: getFormattedDownloadCount('wp28')
    },
    {
      id: 'wp29',
      title: '引越し業者の紹介で稼ぐ方法',
      description: '仲介手数料以外で年収300万円アップの仕組み',
      thumbnail: '/images/wp29-thumb.png',
      category: '収益化',
      pages: 14,
      fileSize: '2.2MB',
      // downloadCount: getFormattedDownloadCount('wp29')
    },
    {
      id: 'wp30',
      title: '土日に集中して3組成約させる方法',
      description: '週末戦士のための超効率営業術',
      thumbnail: '/images/wp30-thumb.png',
      category: '効率化',
      pages: 14,
      fileSize: '2.3MB',
      // downloadCount: getFormattedDownloadCount('wp30')
    }
  ];

  return `
    <div class="download-list-page">
      ${Header()}

      <!-- パンくずリスト -->
      <nav class="breadcrumb">
        <div class="container">
          <a href="/">ホーム</a> &gt; 
          <a href="/master">反響成約マスター</a> &gt; 
          <span>資料ダウンロード</span>
        </div>
      </nav>

      <!-- ページヘッダー -->
      <section class="download-hero">
        <div class="container">
          <h1 class="page-title">資料ダウンロード</h1>
          <p class="page-subtitle">
            反響成約で成果を出すための実践的なノウハウを<br>
            無料でダウンロードいただけます
          </p>
        </div>
      </section>

      <!-- カテゴリーフィルター -->
      <section class="category-filter-section">
        <div class="container">
          <div class="category-filter-wrapper">
            <h3 class="filter-title">カテゴリーで絞り込む</h3>
            <div class="category-filter-buttons">
              <button class="category-filter-btn active" data-category="all">すべて</button>
              <button class="category-filter-btn" data-category="クロージング">クロージング</button>
              <button class="category-filter-btn" data-category="面談術">面談術</button>
              <button class="category-filter-btn" data-category="顧客心理">顧客心理</button>
              <button class="category-filter-btn" data-category="心理分析">心理分析</button>
              <button class="category-filter-btn" data-category="実践ツール">実践ツール</button>
              <button class="category-filter-btn" data-category="交渉術">交渉術</button>
              <button class="category-filter-btn" data-category="競合対策">競合対策</button>
              <button class="category-filter-btn" data-category="フォローアップ">フォローアップ</button>
              <button class="category-filter-btn" data-category="効率化">効率化</button>
              <button class="category-filter-btn" data-category="集客">集客</button>
              <button class="category-filter-btn" data-category="物件案内">物件案内</button>
              <button class="category-filter-btn" data-category="ローン対策">ローン対策</button>
              <button class="category-filter-btn" data-category="説得術">説得術</button>
              <button class="category-filter-btn" data-category="特殊案件">特殊案件</button>
              <button class="category-filter-btn" data-category="収益化">収益化</button>
            </div>
          </div>
        </div>
      </section>

      <!-- 資料一覧 -->
      <section class="download-grid-section">
        <div class="container">
          <div class="download-grid">
            ${whitepapers.map(wp => `
              <div class="download-card" data-category="${wp.category}">
                <div class="card-image">
                  <img src="${wp.thumbnail}" alt="${wp.title}" />
                  <div class="category-badge">${wp.category}</div>
                  ${NEW_RELEASE_CONFIG.enabled && NEW_RELEASE_CONFIG.newIds.includes(wp.id)
                    ? `<div class="new-badge">✨ ${NEW_RELEASE_CONFIG.message}</div>`
                    : ''}
                  <!-- <div class="download-count-badge">👥 ${wp.downloadCount}人がダウンロード</div> -->
                </div>
                <div class="card-content">
                  <h2 class="card-title">${wp.title}</h2>
                  <p class="card-description">${wp.description}</p>
                  <div class="card-meta">
                    <span class="meta-item">PDF資料</span>
                  </div>
                  ${isAvailable(wp.id)
                    ? `<button class="download-button" onclick="window.router.navigate('/master/download/${wp.id}')">
                        ダウンロード
                      </button>`
                    : `<button class="download-button preparing" disabled>
                        ${COMING_SOON_MESSAGE}
                      </button>`
                  }
                </div>
              </div>
            `).join('')}
          </div>
        </div>
      </section>

      <!-- お役立ち資料 -->
      <section class="additional-resources">
        <div class="container">
          <h2 class="section-title">その他のお役立ち資料</h2>
          <div class="resource-list">
            <div class="resource-item">
              <h3>購入仲介用語集</h3>
              <p>購入仲介に関する専門用語をわかりやすく解説</p>
              <a href="/master/glossary" class="resource-link">用語集を見る</a>
            </div>
            <div class="resource-item">
              <h3>月次報告書テンプレート</h3>
              <p>購入検討者への定期報告に使える月次レポート雛形</p>
              <span class="coming-soon">準備中</span>
            </div>
            <div class="resource-item">
              <h3>購入申込書の書き方ガイド</h3>
              <p>トラブルを防ぐ購入申込書の記入ポイントを解説</p>
              <span class="coming-soon">準備中</span>
            </div>
          </div>
        </div>
      </section>

      <!-- CTA -->
      <section style="background: #E60012; padding: 80px 20px; text-align: center; color: white;">
        <div style="max-width: 700px; margin: 0 auto; text-align: center;">
          <h2 style="font-size: 32px; margin: 0 0 20px 0; color: white; text-align: center;">購入仲介の実践方法を学びたい方へ</h2>
          <p style="font-size: 18px; margin: 0 0 40px 0; color: white; line-height: 1.6; text-align: center;">体系的に学べる教育コンテンツもご用意しています</p>
          <a href="/master/lab" style="display: inline-block; background: white; color: #E60012; padding: 15px 40px; border-radius: 50px; text-decoration: none; font-weight: bold; font-size: 18px;">反響成約ラボを見る</a>
        </div>
      </section>

      ${Footer()}
    </div>
    
    <style>
      /* ダウンロード数の非表示 */
      .download-count {
        display: none;
      }

      /* NEWバッジ */
      .new-badge {
        position: absolute;
        top: 10px;
        left: 10px;
        background: linear-gradient(135deg, #FFD700 0%, #FFA500 100%);
        color: #333;
        padding: 6px 14px;
        border-radius: 20px;
        font-weight: bold;
        font-size: 13px;
        z-index: 2;
        box-shadow: 0 3px 8px rgba(255, 215, 0, 0.5), 0 1px 3px rgba(0,0,0,0.3);
        border: 2px solid #FFFFFF;
        letter-spacing: 0.5px;
      }

      /* カテゴリーフィルター */
      .category-filter-container {
        margin: 30px 0;
        background: #f8f8f8;
        padding: 20px;
        border-radius: 8px;
      }
      
      .category-filter-header {
        font-size: 16px;
        font-weight: bold;
        margin-bottom: 15px;
        color: #333;
      }
      
      .category-filter-buttons {
        display: flex;
        flex-wrap: wrap;
        gap: 10px;
      }
      
      .category-filter-btn {
        padding: 8px 20px;
        border: 1px solid #ddd;
        background: white;
        border-radius: 20px;
        cursor: pointer;
        transition: all 0.3s;
        font-size: 14px;
      }
      
      .category-filter-btn:hover {
        background: #f0f0f0;
      }
      
      .category-filter-btn.active {
        background: #E60012;
        color: white;
        border-color: #E60012;
      }
      
      /* ダウンロードカードの調整 */
      .download-card {
        transition: opacity 0.3s, transform 0.3s;
      }
      
      .download-card.hidden {
        display: none;
      }
      
      /* 準備中ボタンのスタイル */
      .download-button.preparing {
        background: #999;
        cursor: not-allowed;
        opacity: 0.7;
      }
      
      .download-button.preparing:hover {
        background: #999;
        transform: none;
      }
    </style>
  `;
}